import React from "react";
import {
  Button,
  makeStyles,
  tokens,
  Tooltip,
} from "@fluentui/react-components";
import { SignOut24Regular } from "@fluentui/react-icons";
import { useUserSessionContext } from "../../../contextApis/UserSessionContext";

const useStyles = makeStyles({
  content: {
    width: "100%",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: tokens.colorTransparentBackground,
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  logoutButton: {
    width: "100%",
    height: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    padding: "8px",
  },
});

const Logout: React.FC = () => {
  const styles = useStyles();

  const { logout, isLoggedIn } = useUserSessionContext();

  if (!isLoggedIn) return null;

  return (
    <Tooltip content="Logout" relationship="label">
      <div className={styles.content} onClick={logout}>
        <Button
          className={styles.logoutButton}
          icon={<SignOut24Regular />}
          appearance="transparent"
        />
      </div>
    </Tooltip>
  );
};

export default Logout;
